import React from "react"
import clsx from "clsx"
import { Drawer, Grid2 } from "@mui/material"

import { ContainerProps } from "@/components/Sidebar/protocols"
import useStyles from "@/components/Sidebar/Container/styles"

export const Container = (props: ContainerProps) => {
	const { children, variant, isCollapsed } = props
	const classes = useStyles({ variant })

	const drawerStateClassName = clsx("sidebar-drawer", {
		"sidebar-drawer--open": !isCollapsed,
		"sidebar-drawer--close": isCollapsed
	})

	const paperSx = isCollapsed ? classes.drawerClose : classes.drawerOpen

	return (
		<Drawer
			variant="permanent"
			className={drawerStateClassName}
			sx={classes.drawer}
			slotProps={{
				paper: {
					className: drawerStateClassName,
					sx: paperSx
				}
			}}
		>
			<Grid2 container direction="column" wrap="nowrap" sx={classes.drawerInternalContainer}>
				{children}
			</Grid2>
		</Drawer>
	)
}